export default {
  title: 'Projects',
  titleButton: 'New project',
  titleButtonShort: 'New',
  cards: {
    actions: {
      edit: 'Edit project name',
      share: 'Share',
      delete: 'Delete project'
    },
    footer: {
      itemsCount: '{count} items'
    },
    noAccessTooltip: "You don't have access to edit this {type}",
    noPermissionsTooltip: "You don't have permissions to edit this {type}"
  },
  emptyState: {
    noProjectsCreated: "You haven't created any projects yet",
    button: 'Create your first project',
    noProjectsBeenShared: 'No projects have been shared with you yet.'
  },
  createDialog: {
    ariaLabel: 'Create project form dialog',
    title: 'Create new project',
    createButton: 'Create project',
    fields: {
      title: 'Project name',
      titlePlaceholder: 'Type the project name',
      maxLengthHelper: 'Up to {maxLength} characters allowed'
    },
    success: 'Project created successfully'
  },
  createFolderDialog: {
    ariaLabel: 'Create folder form dialog',
    title: 'New folder',
    createButton: 'Create folder',
    fields: {
      title: 'Folder name',
      titlePlaceholder: 'Type the folder name',
      maxLengthHelper: 'Up to {maxLength} characters allowed'
    },
    success: 'Folder created successfully'
  },
  filters: {
    search: 'Search project',
    searchResults: '{elements} results by "{query}"',
    noResults: 'No projects were found',
    noAssetsResults: 'No assets were found',
    noResultsFolders: 'No folders were found',
    noResultsMaps: 'No maps were found',
    noResultsWorkflows: 'No workflows were found',
    noResultsTags: 'No assets were found',
    total: `{itemCount} {itemCount, plural,
      one {project}
      other {projects}
    }`,
    owner: {
      all: 'Owned by anyone',
      mine: 'Owned by me',
      others: 'Owned by others'
    },
    type: {
      all: 'All types',
      folders: 'Folders',
      maps: 'Maps',
      workflows: 'Workflows'
    },
    order: {
      updatedAt: 'Last updated',
      title: 'A-Z'
    }
  },
  editDialog: {
    ariaLabel: 'Edit project form dialog',
    title: 'Edit project name',
    saveButton: 'Save changes',
    fields: {
      title: 'Project name',
      titlePlaceholder: 'Type the project name',
      maxLengthHelper: 'Up to {maxLength} characters allowed'
    },
    success: 'Name changed successfully'
  },
  editFolderDialog: {
    ariaLabel: 'Edit folder form dialog',
    title: 'Edit folder name',
    saveButton: 'Save changes',
    fields: {
      title: 'Folder name',
      titlePlaceholder: 'Type the folder name',
      maxLengthHelper: 'Up to {maxLength} characters allowed'
    },
    success: 'Name changed successfully'
  },
  projectDetails: {
    counter: `{itemCount} {itemCount, plural,
      one {item}
      other {items}
    }`,
    newFolder: 'New folder',
    card: {
      ariaLabel: 'Folder card'
    },
    actions: {
      ariaLabel: 'Folder card actions',
      edit: 'Edit folder name',
      editFolder: 'Edit folder name',
      editProject: 'Edit project name',
      share: 'Share',
      moveTo: 'Move to',
      delete: 'Delete folder',
      deleteFolder: 'Delete folder',
      deleteProject: 'Delete project'
    },
    noAccessTooltip: "You don't have access to edit this {type}",
    noPermissionsTooltip: "You don't have permissions to edit this {type}"
  },
  deleteDialog: {
    ariaLabel: 'Delete project form dialog',
    title: 'Delete project',
    description: 'Are you sure you want to delete {name}?',
    warning: 'This action cannot be undone.',
    info: "Assets inside this project won't be deleted.",
    deleteButton: 'Yes, delete',
    success: 'Project deleted successfully'
  },
  deleteFolderDialog: {
    ariaLabel: 'Delete folder form dialog',
    title: 'Delete folder',
    description: 'Are you sure you want to delete {name}?',
    warning: 'This action cannot be undone.',
    info: "Assets inside this folder won't be deleted.",
    deleteButton: 'Yes, delete',
    success: 'Folder deleted successfully'
  },
  projectDetailsEmptyState: {
    title: 'This {type} is empty',
    editorDescription: 'Start organizing your maps and workflows in this {type}.',
    editorDescriptionSecondLine: "Or use the 'New folder' button.",
    nonEditorDescription: 'No maps or workflows have been shared with you yet.',
    learnMore: 'Learn more'
  },
  moveFolderDialog: {
    ariaLabel: 'Move folder dialog',
    title: 'Move {type} {name}',
    moveButton: 'Move here',
    newProject: 'New project',
    newFolder: 'New folder',
    success: '{type} moved to "{folderName}"',
    moveButtonTooltip: 'This item is already in this folder',
    emptyState: 'This {type} is empty',
    emptyStateProject: 'This project is empty',
    emptyStateFolder: 'This folder is empty',
    assetItselfTooltip: 'This is the {type} you are moving',
    emptyStateNoProjects: {
      caption: "You haven't created any projects yet.",
      description: 'You need to create a project to add the {assetType} shortcut.',
      button: 'Create your first project'
    }
  },
  folderSelectionHeader: {
    tabs: {
      all: 'All projects',
      mine: 'Owned by me',
      others: 'Owned by others'
    }
  },
  createShortcutDialog: {
    addButtonTooltip: 'This item is already in this folder',
    ariaLabel: 'Create shortcut dialog',
    title: 'Create shortcut of {name}',
    addButton: 'Add here',
    success: 'Shortcut added to "{folderName}"',
    moveButtonTooltip: 'This item is already in this folder',
    tabs: {
      all: 'All projects',
      mine: 'Owned by me',
      others: 'Owned by others'
    },
    newProject: 'New project',
    newFolder: 'New folder',
    emptyState: 'This {type} is empty',
    emptyStateProject: 'This project is empty',
    emptyStateFolder: 'This folder is empty'
  },
  shortcuts: {
    actions: {
      ariaLabel: 'Shortcut card actions',
      deleteShortcut: 'Delete shortcut'
    },
    private: {
      tooltip: "You don't have access to this asset"
    }
  },
  deleteShortcutDialog: {
    ariaLabel: 'Delete shortcut form dialog',
    title: 'Delete shortcut',
    description: 'Are you sure you want to delete {name}?',
    warning: 'This action cannot be undone.',
    deleteButton: 'Yes, delete',
    success: 'Shortcut deleted successfully'
  },
  sharingDialog: {
    footerAlertContent:
      'Lower-level folders will inherit the settings you define for this {assetType}. Check our <a>documentation</a>.',
    alertConfirmationContent:
      'The {assetType} has not yet been shared with other users. If you close the dialog now, the {assetType} will keep the current permissions.',
    restrictedTooltipLabel:
      'This {assetType} is accessible to the entire organization because access is granted through its parent {parentAssetType}.'
  },
  loginPrompt: {
    title: "Oops! You can't access this project",
    content:
      "Use your CARTO credentials or sign up to access this project. If the project exists and is shared with you, you'll be automatically redirected to it.",
    contentEmbedded:
      'Login or sign up using your CARTO credentials in a new window. Then, refresh this page to access the project.'
  }
}
